module.exports = __webpack_public_path__ + "assets/img/free_2.60b59a19.png";